export const BankAccounts = [
  { value: 'Corriente', label: 'Corriente', children: 'Corriente' },
  { value: 'Vista', label: 'Vista', children: 'Vista' },
  { value: 'Ahorro', label: 'Ahorro', children: 'Ahorro' },
].sort((a, b) => a.value.localeCompare(b.value));
